import { useEffect, useRef } from 'react';
import OktaSignIn from '@okta/okta-signin-widget';
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';

const OktaSignInWidget = ({ config, onSuccess, onError }) => {
  const widgetRef = useRef();
  useEffect(() => {
    if (!widgetRef.current) {
      return false;
    }

    const widget = new OktaSignIn(config);

    widget
      .showSignInToGetTokens({
        el: widgetRef.current,
      })
      .then(onSuccess)
      .catch(onError);

    return () => widget.remove();
  }, [config, onSuccess, onError]);

  return (
    <div className="sign-in-wrapper">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col text-center">
            <div>
              <h2>ControlPoint</h2>
              <h4>Please sign in to continue</h4>
            </div>
            <div ref={widgetRef} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default OktaSignInWidget;
